import styled from 'styled-components';
import { StylesConfig } from 'react-select';

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem;
  background-color: #1e88e5;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 34rem;
  padding: 2.5rem 2rem 2rem;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);

  > svg {
    margin-bottom: 1.75rem;
  }

  form {
    width: 100%;
    display: flex;
    flex-direction: column;

    h1 {
      font-family: 'RedHatDisplay-Bold';
      font-size: 1.34rem;
      margin: 0 0 0.25rem;
    }

    p.description {
      font-family: 'RedHatDisplay-Regular';
      font-size: 0.85rem;
      color: #666;
      line-height: 1.5;
      margin: 0 0 1.5rem;
    }

    h4 {
      font-family: 'RedHatDisplay-Regular';
      font-size: 0.88rem;
      font-weight: normal;
      margin: 0 0 0.4rem;
    }

    > div + h4 {
      margin-top: 1.2rem;
    }

    .checkbox {
      margin-top: 1.2rem;
    }

    .primary-button {
      margin-top: 1.75rem;
      height: 3.33rem;
      font-family: 'RedHatDisplay-Bold';
      font-size: 1.1rem;
      border-radius: 0.55rem;
      box-shadow: 0px 3px 15px rgba(255, 152, 0, 0.3);
    }
  }
`;

export const UserSummary = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.9rem 1.1rem;
  margin-bottom: 1.5rem;
  border-radius: 0.56rem;
  background: rgba(30, 136, 229, 0.06);

  strong {
    font-family: 'RedHatDisplay-Bold';
    font-size: 0.95rem;
    color: #323232;
  }

  span {
    font-family: 'RedHatDisplay-Regular';
    font-size: 0.85rem;
    color: #666;
    word-break: break-all;
  }
`;

/**
 * Aviso de quem está na escola padrão. Não é um erro — o cadastro pode ser
 * concluído assim mesmo, só a criação de torneio fica de fora — daí o azul da
 * marca em vez do vermelho de validação.
 */
export const Notice = styled.p`
  width: 100%;
  padding: 0.9rem 1.1rem;
  margin: 0 0 1.25rem;
  border-radius: 0.56rem;
  border-left: 3px solid #1e88e5;
  background: rgba(30, 136, 229, 0.06);
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.85rem;
  color: #4a4a4a;
  line-height: 1.5;
`;

/**
 * O `> div + h4` do Content deixa de casar com o rótulo seguinte quando esta
 * dica entra entre o select e ele, então o espaçamento é reposto aqui.
 */
export const FieldHint = styled.p`
  margin: 0.45rem 0 0;
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.78rem;
  color: #888;
  line-height: 1.45;

  & + h4 {
    margin-top: 1.2rem;
  }
`;

export const PolicyButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-family: 'RedHatDisplay-Bold';
  font-size: inherit;
  color: #ff9800;
  cursor: pointer;
  text-decoration: underline;

  &:focus-visible {
    outline: 2px solid #ff9800;
    outline-offset: 2px;
  }
`;

export const LogoutButton = styled.button`
  margin-top: 1.5rem;
  align-self: center;
  background: none;
  border: none;
  padding: 0.4rem;
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.85rem;
  color: #666;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #323232;
  }

  &:focus-visible {
    outline: 2px solid #ff9800;
    outline-offset: 2px;
  }
`;

export const ErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.75rem;
  padding: 1rem 0;
  width: 100%;

  .error-icon {
    line-height: 0;
  }

  h2 {
    font-family: 'RedHatDisplay-Bold';
    font-size: 1.2rem;
    color: #333;
    margin: 0;
  }

  p {
    font-family: 'RedHatDisplay-Regular';
    font-size: 0.88rem;
    color: #666;
    line-height: 1.5;
    margin: 0;
  }
`;

export const schoolSelectStyles: StylesConfig<
  { label: string; value: string },
  false
> = {
  indicatorSeparator: (providedStyles: any) => ({
    ...providedStyles,
    display: 'none',
  }),
  container: (providedStyles: any) => ({
    ...providedStyles,
    fontFamily: 'RedHatDisplay-Regular',
    fontSize: '1rem',
  }),
  control: (
    providedStyles: any,
    state: { isFocused: any; menuIsOpen: any },
  ) => ({
    ...providedStyles,
    paddingLeft: '1.1rem',
    margin: 0,
    height: 'auto',
    borderRadius: '0.56rem',
    border:
      state.isFocused || state.menuIsOpen
        ? '1px solid rgba(255, 152, 0, 1)'
        : '1px solid #e2e2e2',
  }),
  valueContainer: (providedStyles: any) => ({
    ...providedStyles,
    padding: '0 1.167rem',
    height: '3.167rem',
    color: '#1e88e5',
  }),
  option: (providedStyles: any, state: { isFocused: any }) => ({
    ...providedStyles,
    color: '#1e88e5',
    background: state.isFocused ? 'rgba(226, 226, 226, 0.2)' : '#fff',
  }),
  singleValue: (providedStyles: any) => ({
    ...providedStyles,
    color: '#1e88e5',
  }),
  dropdownIndicator: (providedStyles: any, state: { isFocused: any }) => ({
    ...providedStyles,
    margin: 0,
    padding: 0,
    stroke: state.isFocused ? 'rgba(255, 152, 0, 1)' : '#1e88e5',
  }),
  indicatorsContainer: (providedStyles: any) => ({
    ...providedStyles,
    height: 'auto',
    margin: 0,
    padding: '0px 2rem',
  }),
};
